import { CommonModule } from '@angular/common';
import { CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';

import {
  AppCellDirective,
  AppCellDefDirective,
  AppFooterCellDirective,
  AppFooterCellDefDirective,
  AppHeaderCellDirective,
  AppHeaderCellDefDirective,
} from './cell';
import { AppColumnDefDirective } from './column-def';
import { AppNoDataRowDirective } from './no-data-row';
import {
  AppFooterRowComponent,
  AppFooterRowDefDirective,
  AppHeaderRowComponent,
  AppHeaderRowDefDirective,
  AppRowComponent,
  AppRowDefDirective,
} from './row';
import { AppTableComponent } from './table';

const APP_TABLE_DECLARABLES = [
  AppTableComponent,
  AppColumnDefDirective,
  AppHeaderCellDefDirective,
  AppCellDefDirective,
  AppFooterCellDefDirective,
  AppHeaderCellDirective,
  AppCellDirective,
  AppFooterCellDirective,
  AppHeaderRowDefDirective,
  AppRowDefDirective,
  AppFooterRowDefDirective,
  AppHeaderRowComponent,
  AppRowComponent,
  AppFooterRowComponent,
  AppNoDataRowDirective,
];

/**
 * Internal `app-table` stack. Re-exports `CdkTableModule` because the
 * `App*` directives extend their `Cdk*` counterparts and depend on
 * primitives from the CDK (row outlets, cell outlet, view repeater)
 * being declared in the consumer's view.
 */
@NgModule({
  imports: [CommonModule, CdkTableModule],
  declarations: APP_TABLE_DECLARABLES,
  exports: [CdkTableModule, ...APP_TABLE_DECLARABLES],
})
export class AppTableModule {}
